// composables/useChatState.js - FIXED to prevent multiple subscriptions
import { ref, onBeforeUnmount } from 'vue'
import { chatStateManager } from '../lib/chatStateManager'

// Global subscription management
let globalStateSubscription = null;
let subscriptionCount = 0;

export function useChatState() {
  // Reactive state
  const messages = ref([]);
  const customer = ref(null);
  const conversation = ref(null);
  const customerName = ref('');
  const currentPhase = ref('start');

  let stateUnsubscribe = null;

  const subscribeToState = () => {
    // Prevent multiple global subscriptions
    subscriptionCount++;
    console.log(`🔗 useChatState subscription request #${subscriptionCount}`);

    // If there's already a global subscription, just use it
    if (globalStateSubscription) {
      console.log('🔗 Reusing existing global state subscription');
      
      // Get initial state for this component
      const initialState = chatStateManager.getState();
      messages.value = [...(initialState.messages || [])];
      customer.value = initialState.customer;
      conversation.value = initialState.conversation;
      customerName.value = initialState.customerName || '';
      currentPhase.value = initialState.currentPhase || 'start';
      
      return;
    }

    // Create the single global subscription
    console.log('🔗 Creating new global state subscription');
    globalStateSubscription = chatStateManager.subscribe((newState) => {
      console.log('🔄 Global state update received:', {
        messageCount: newState.messages?.length || 0,
        phase: newState.currentPhase,
        hasCustomer: !!newState.customer,
        hasConversation: !!newState.conversation
      });

      // Update all reactive states (this will update all components using this composable)
      messages.value = [...(newState.messages || [])];
      customer.value = newState.customer;
      conversation.value = newState.conversation;
      customerName.value = newState.customerName || '';
      currentPhase.value = newState.currentPhase || 'start';
    });

    // Get initial state
    const initialState = chatStateManager.getState();
    messages.value = [...(initialState.messages || [])];
    customer.value = initialState.customer;
    conversation.value = initialState.conversation;
    customerName.value = initialState.customerName || '';
    currentPhase.value = initialState.currentPhase || 'start';

    console.log('💬 Global state subscription initialized:', {
      messageCount: messages.value.length,
      phase: currentPhase.value
    });
  };

  const unsubscribeFromState = () => {
    subscriptionCount--;
    console.log(`🔗 useChatState unsubscribe request. Remaining: ${subscriptionCount}`);

    // Only unsubscribe from global when all components are done
    if (subscriptionCount <= 0 && globalStateSubscription) {
      console.log('🔗 Cleaning up global state subscription');
      globalStateSubscription();
      globalStateSubscription = null;
      subscriptionCount = 0;
    }
  };

  // Cleanup on unmount
  onBeforeUnmount(() => {
    unsubscribeFromState();
  });

  return {
    messages,
    customer,
    conversation,
    customerName,
    currentPhase,
    subscribeToState,
    unsubscribeFromState
  };
}